<!-- Header hidden in screenshot editing mode -->
@if (state!==FeedbackState.WithScreenshot) {
  <cs-header>
    <cs-header-title>{{ title || LL.sendFeedback.title() }}</cs-header-title>
  </cs-header>
}

<!-- Screenshot editing mode - fixed layout -->
@if (state===FeedbackState.WithScreenshot) {
  <cs-screenshot-annotator [imageDataUrl]="screenshotDataUrl" (closeRequested)="onCloseButtonClicked()">
    <div class="form-header">
      <p class="form-title">{{ LL.sendFeedback.writeFeedback.title() }}</p>
      <p class="form-subtitle">{{ LL.sendFeedback.writeFeedback.subtitle({email: auth.user.email}) }}</p>
    </div>
    <cs-textarea #textarea [(value)]="feedbackDescription" [placeholder]="placeholder" class="compact"></cs-textarea>
    <div class="form-actions">
      <cs-button primary (click)="onSubmitButtonClicked()">{{ LL.sendFeedback.buttons.submit() }}</cs-button>
    </div>
  </cs-screenshot-annotator>
}

@if (state!==FeedbackState.WithScreenshot) {
  <cs-content>
    <cs-card-list>
      <!-- State 1: Choose feedback type -->
      @if (state===FeedbackState.ChooseType) {
        <cs-card>
          <p class="card-header">{{ LL.sendFeedback.headers.howCanWeHelp() }}</p>
          <div class="feedback-type-grid">
            @for (info of typeInfos; track info) {
              <button class="feedback-type-card" (click)="onTypeSelected(info.type)">
                <cs-icon [name]="info.icon"></cs-icon>
                <div class="card-content">
                  <span class="card-title">{{ info.title }}</span>
                  <span class="card-description">{{ info.description }}</span>
                </div>
              </button>
            }
          </div>
        </cs-card>
      }
      <!-- Support Card (shown in ChooseType state) -->
      @if (state===FeedbackState.ChooseType) {
        <cs-support-card [description]="LL.profile.reportIssueInfoFeedback()"></cs-support-card>
      }
      <!-- State 2: Write feedback form (without screenshot) -->
      @if (state===FeedbackState.WithOutScreenshot) {
        <cs-card class="feedback-form-card">
          <div class="feedback-form">
            <div class="form-header">
              <p class="form-title">{{ LL.sendFeedback.writeFeedback.title() }}</p>
              <p class="form-subtitle">{{ LL.sendFeedback.writeFeedback.subtitle({email: auth.user.email}) }}</p>
            </div>
            <cs-textarea #textarea [(value)]="feedbackDescription" [placeholder]="placeholder"></cs-textarea>
            <div class="form-actions">
              <cs-button secondary icon="camera"
              (click)="onAddScreenshotClicked()">{{ LL.sendFeedback.buttons.addScreenshot() }}</cs-button>
              <cs-button primary (click)="onSubmitButtonClicked()">{{ LL.sendFeedback.buttons.submit() }}</cs-button>
            </div>
          </div>
        </cs-card>
      }
    </cs-card-list>
  </cs-content>
}
